var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountBalance = function SvgAccountBalance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.967 0H.033S0 0 0 .034v21.932S0 22 .033 22H28V.034S28 0 27.967 0ZM2.257 2.25h23.486v3.758H2.257V2.25Zm23.486 17.5H2.257v-11h23.488v11Zm-7.658-1.998h5.65v-2.741h-5.65v2.741Z",
    fill: "#AFAFAF"
  })));
};
export default SvgAccountBalance;